var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathroomsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_677_7070)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3125 12.8757H2.81248V3.39198C2.81248 2.75073 3.40875 2.18821 4.08934 2.18821H6.44061C7.10438 2.18821 7.63873 2.72821 7.64438 3.38634C6.5475 3.66198 5.62502 4.67448 5.62502 5.7432V7.25071C5.62502 7.56011 5.87814 7.81323 6.18754 7.81323H10.125C10.4344 7.81323 10.6875 7.56011 10.6875 7.25071V5.74325C10.6875 4.65761 9.82689 3.66198 8.76941 3.39198C8.76941 2.10948 7.7288 1.06323 6.44066 1.06323H4.08939C2.79002 1.06323 1.6875 2.132 1.6875 3.39198V12.8757C0.759375 12.8701 0.00564258 13.6239 0 14.552C0 15.0357 0.2025 15.4914 0.562518 15.812V18.7595C0.562518 21.0488 1.58066 23.012 3.22877 24.2888L2.30629 26.1226C2.16564 26.3982 2.27818 26.7357 2.55941 26.8763C2.83505 27.0169 3.17255 26.9044 3.31314 26.6232L4.17941 24.8963C5.31568 25.5038 6.58689 25.8188 7.87504 25.8075H19.125C20.4132 25.8188 21.6844 25.5038 22.8206 24.8963L23.6869 26.6232C23.8276 26.8988 24.1651 27.0113 24.4406 26.8763C24.7163 26.7413 24.8288 26.3981 24.6938 26.1226L23.7713 24.2832C25.4194 23.0119 26.4375 21.0432 26.4375 18.7538V15.8063C26.7919 15.4969 27.0001 15.0413 27.0001 14.5632C27 13.6295 26.2463 12.8757 25.3125 12.8757ZM8.20689 4.43823C8.87625 4.43823 9.56254 5.09636 9.56254 5.74325V6.68825H6.75V5.74325C6.75 5.11888 7.50938 4.43823 8.20689 4.43823ZM25.3125 18.7595C25.3125 22.1402 22.6519 24.6883 19.125 24.6883H7.87498C4.34811 24.6882 1.6875 22.1401 1.6875 18.7595V16.2508H25.3125V18.7595ZM25.3125 15.1258H1.70438C1.42314 15.1258 1.17002 14.9233 1.13063 14.6476C1.08 14.2989 1.35 14.0007 1.6875 14.0007H25.2956C25.5769 14.0007 25.83 14.2032 25.8694 14.4789C25.92 14.8276 25.65 15.1258 25.3125 15.1258Z",
    fill: "#34354B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_7070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomsIcon);
export default __webpack_public_path__ + "static/media/bathroomsIcon.a2b4df0d73d5713ce14b9a139f069214.svg";
export { ForwardRef as ReactComponent };